// helpers/constants.js

export const SUPPORTED_FORMATS = [
  'header',
  'question',
  'dropdown',
  'textinput',
  'checkbox',
  'subheader',
  'disclosure',
  'bullet',
  'text',
  'pricing',
  'separator',
];

export const DEFAULT_FORM_ID = 'HVAC';
